/**
 * src/api/http.js
 */
import axios from "axios";
import qs from "qs";
import CookieService from "./CookieService";

/**
 *
 * parse error response
 */
function parseError(messages) {
  // error
  if (messages) {
    if (messages instanceof Array) {
      return Promise.reject({ messages: messages });
    } else {
      return Promise.reject({ messages: [messages] });
    }
  } else {
    return Promise.reject({ messages: ["error"] });
  }
}

/**
 * parse response
 */
function parseBody(response) {
  //  if (response.status === 200 && response.data.status.code === 200) { // - if use custom status code
  if (response.status === 200) {
    return response.data.result;
  } else {
    return this.parseError(response.data.messages);
  }
}

/**
 * axios instance
 */
let instance = axios.create({
  baseURL: process.env.REACT_APP_TAKAOKABOTS_API_URL,
  paramsSerializer: function (params) {
    return qs.stringify(params, { indices: false });
  },
});

// request header
instance.interceptors.request.use(
  (config) => {
    const apiToken = CookieService.get("api_token");
    if (apiToken) {
      config.headers["Authorization"] = `Bearer ${apiToken}`;
    }
    config.headers["Accept"] = "application/json";
    // config.headers = { Authorization: "Bearer " + apiToken, Accept: "application/json" };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// response parse
instance.interceptors.response.use(
  (response) => {
    //return parseBody(response);
    return response;
  },
  (error) => {
    console.warn("Error status", error.response.status);
    if (error.response) {
      return parseError(error.response.data);
    } else {
      return Promise.reject(error);
    }
  }
);

export const http = instance;
